export enum Key {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  SPACE = ' ',
}
